import app from 'flarum/forum/app';

export default function (name: string): boolean {
    return (app.forum.attribute<string[]>('formulaireHorizontalLayout') || []).indexOf(name) !== -1;
}
